var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationBell = function SvgNotificationBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M43.5 19.333a14.5 14.5 0 0 0-29 0c0 16.917-7.25 21.75-7.25 21.75h43.5s-7.25-4.833-7.25-21.75M33.181 50.75a4.833 4.833 0 0 1-8.362 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4E00",
    fillRule: "evenodd",
    d: "M57.358 2.606a2.18 2.18 0 0 1 .047 3.042L32.962 31.346a2.1 2.1 0 0 1-1.517.654 2.1 2.1 0 0 1-1.517-.654l-7.333-7.71a2.18 2.18 0 0 1 .047-3.041 2.085 2.085 0 0 1 2.987.048l5.816 6.115L54.37 2.654a2.085 2.085 0 0 1 2.987-.048",
    clipRule: "evenodd"
  })));
};
export default SvgNotificationBell;